import { RowExportTypePdf } from "types";
import { convertNumber } from "utils";
import { PdfTemplate } from "components";
import moment from "moment";
import { Payload } from "../../types/CustomerOrderFullfilment";

export function ExportPdfCustomerOrderFullfilment({ dataList }: {
    dataList: Payload['data'],
}) {

    const columns = [
        { header: 'NO', key: 'no', width: 5 },
        { header: 'CODE', key: 'code', width: 10 },
        { header: 'CUSTOMER NAME', key: 'customer_name', width: 20 },
        { header: 'ORDER ID', key: 'order_id', width: 20 },
        { header: 'SHIPMENT DATE', key: 'shipment_date', width: 20 },
        { header: 'TOTAL QTY', key: 'total_qty', width: 20 },
        { header: 'PROMISE DATE', key: 'promise_date', width: 20 },
    ];

    const dataMap: RowExportTypePdf[] = dataList.map((item, index) => ({
        no: index + 1,
        code: item.customer_code,
        customer_name: item.customer_name,
        order_id: item.trx_code,
        shipment_date: moment(item.transaction_date).format('DD/MM/YYYY'),
        total_qty: {
            text: convertNumber(item.total_qty ?? 0).intoNormalAmount,
            style: { textAlign: "right" }
        },
        promise_date: moment(item.promize_date).format('DD/MM/YYYY'),
    }))

    return (
        <PdfTemplate
            data={dataMap}
            module="INVENTORY"
            title = "CUSTOMER ORDER FULLFILMENT"
            column={columns}
        />
    )
}